import React from 'react';

function Solutions() {
  const [activeTab, setActiveTab] = React.useState(0);

  const switchTab = (index) => {
    setActiveTab(index);
  };

  return (
    <section className="section solutions-section" id="solutions">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Designed for Every Role</h2>
        </div>

        <div className="tabs-row">
          <button className={`tab-button ${activeTab === 0 ? 'active' : ''}`} onClick={() => switchTab(0)}>Admin</button>
          <button className={`tab-button ${activeTab === 1 ? 'active' : ''}`} onClick={() => switchTab(1)}>Teachers</button>
          <button className={`tab-button ${activeTab === 2 ? 'active' : ''}`} onClick={() => switchTab(2)}>Students</button>
        </div>

        {/* Admin Tab */}
        <div className={`tab-content ${activeTab === 0 ? 'active' : ''}`}>
          <div className="tab-features">
            <ul>
              <li>Manage admissions and student records</li>
              <li>Generate fee receipts and track payments</li>
              <li>Track staff attendance and performance</li>
              <li>Full analytics dashboard with insights</li>
              <li>Control user permissions and access</li>
              <li>Export comprehensive reports</li>
            </ul>
          </div>
          <div className="tab-screenshot">
            <div style={{ width: '90%', height: '90%', display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ display: 'flex', gap: '12px' }}>
                <div style={{ flex: 1, background: 'linear-gradient(135deg, #2563EB, #1E40AF)', borderRadius: '12px', padding: '20px', color: 'white' }}>
                  <div style={{ fontSize: '12px', opacity: 0.9, marginBottom: '8px' }}>Total Revenue</div>
                  <div style={{ fontSize: '28px', fontWeight: '900' }}>₹45.2L</div>
                  <div style={{ fontSize: '11px', opacity: 0.8, marginTop: '4px' }}>+12% from last month</div>
                </div>
                <div style={{ flex: 1, background: 'white', border: '2px solid #E2E8F0', borderRadius: '12px', padding: '20px' }}>
                  <div style={{ fontSize: '12px', color: '#64748B', marginBottom: '8px' }}>Staff Present</div>
                  <div style={{ fontSize: '28px', fontWeight: '900', color: '#0F172A' }}>142/156</div>
                  <div style={{ fontSize: '11px', color: '#10B981', marginTop: '4px' }}>91% attendance</div>
                </div>
              </div>
              <div style={{ flex: 1, background: 'white', border: '2px solid #E2E8F0', borderRadius: '12px', padding: '16px' }}>
                <div style={{ fontSize: '13px', fontWeight: '700', color: '#0F172A', marginBottom: '12px' }}>Recent Admissions</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', background: '#F8FAFC', borderRadius: '6px' }}>
                    <span style={{ fontSize: '12px', color: '#334155' }}>Grade 10 - Science</span>
                    <span style={{ fontSize: '12px', fontWeight: '700', color: '#2563EB' }}>+5 students</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', background: '#F8FAFC', borderRadius: '6px' }}>
                    <span style={{ fontSize: '12px', color: '#334155' }}>Grade 8 - Commerce</span>
                    <span style={{ fontSize: '12px', fontWeight: '700', color: '#2563EB' }}>+3 students</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Teachers Tab */}
        <div className={`tab-content ${activeTab === 1 ? 'active' : ''}`}>
          <div className="tab-features">
            <ul>
              <li>Mark attendance quickly and efficiently</li>
              <li>Create assignments and share materials</li>
              <li>Grade exams and publish results</li>
              <li>Communicate with parents directly</li>
              <li>View class schedules and timetables</li>
              <li>Track student progress and performance</li>
            </ul>
          </div>
          <div className="tab-screenshot">
            <div style={{ width: '90%', height: '90%', display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ background: 'linear-gradient(135deg, #10B981, #059669)', borderRadius: '12px', padding: '20px', color: 'white' }}>
                <div style={{ fontSize: '13px', opacity: 0.9, marginBottom: '8px' }}>Today's Classes</div>
                <div style={{ fontSize: '32px', fontWeight: '900' }}>5 Classes</div>
                <div style={{ fontSize: '12px', opacity: 0.8, marginTop: '4px' }}>Next: Math - Grade 10A at 10:30 AM</div>
              </div>
              <div style={{ flex: 1, background: 'white', border: '2px solid #E2E8F0', borderRadius: '12px', padding: '16px' }}>
                <div style={{ fontSize: '13px', fontWeight: '700', color: '#0F172A', marginBottom: '12px' }}>Pending Tasks</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', background: '#FEF3C7', borderRadius: '8px', borderLeft: '3px solid #F59E0B' }}>
                    <input type="checkbox" style={{ width: '16px', height: '16px' }} />
                    <span style={{ fontSize: '12px', color: '#334155' }}>Grade assignments - Due Today</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', background: '#DBEAFE', borderRadius: '8px', borderLeft: '3px solid #2563EB' }}>
                    <input type="checkbox" style={{ width: '16px', height: '16px' }} />
                    <span style={{ fontSize: '12px', color: '#334155' }}>Prepare lesson plan for tomorrow</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', background: '#D1FAE5', borderRadius: '8px', borderLeft: '3px solid #10B981' }}>
                    <input type="checkbox" style={{ width: '16px', height: '16px' }} />
                    <span style={{ fontSize: '12px', color: '#334155' }}>Update attendance records</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Students Tab */}
        <div className={`tab-content ${activeTab === 2 ? 'active' : ''}`}>
          <div className="tab-features">
            <ul>
              <li>Access assignments and learning materials</li>
              <li>View grades and exam results</li>
              <li>Check attendance records</li>
              <li>See class schedules and timetables</li>
              <li>Track fee payment status</li>
              <li>Receive notifications and announcements</li>
            </ul>
          </div>
          <div className="tab-screenshot">
            <div style={{ width: '90%', height: '90%', display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ display: 'flex', gap: '12px', height: '90px' }}>
                <div style={{ flex: 1, background: 'linear-gradient(135deg, #7C3AED, #6D28D9)', borderRadius: '12px', padding: '16px', color: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <div style={{ fontSize: '11px', opacity: 0.9 }}>Attendance</div>
                  <div style={{ fontSize: '26px', fontWeight: '900' }}>95%</div>
                </div>
                <div style={{ flex: 1, background: 'linear-gradient(135deg, #F59E0B, #D97706)', borderRadius: '12px', padding: '16px', color: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <div style={{ fontSize: '11px', opacity: 0.9 }}>Grade Average</div>
                  <div style={{ fontSize: '26px', fontWeight: '900' }}>A+</div>
                </div>
                <div style={{ flex: 1, background: 'linear-gradient(135deg, #EF4444, #DC2626)', borderRadius: '12px', padding: '16px', color: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <div style={{ fontSize: '11px', opacity: 0.9 }}>Pending Fees</div>
                  <div style={{ fontSize: '26px', fontWeight: '900' }}>₹0</div>
                </div>
              </div>
              <div style={{ flex: 1, background: 'white', border: '2px solid #E2E8F0', borderRadius: '12px', padding: '16px' }}>
                <div style={{ fontSize: '13px', fontWeight: '700', color: '#0F172A', marginBottom: '12px' }}>Upcoming Assignments</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{ padding: '10px', background: '#FEF3C7', borderRadius: '8px', borderLeft: '3px solid #F59E0B' }}>
                    <div style={{ fontSize: '12px', fontWeight: '700', color: '#0F172A' }}>Mathematics - Chapter 5</div>
                    <div style={{ fontSize: '11px', color: '#64748B', marginTop: '2px' }}>Due: Jan 20, 2026</div>
                  </div>
                  <div style={{ padding: '10px', background: '#DBEAFE', borderRadius: '8px', borderLeft: '3px solid #2563EB' }}>
                    <div style={{ fontSize: '12px', fontWeight: '700', color: '#0F172A' }}>Science Project</div>
                    <div style={{ fontSize: '11px', color: '#64748B', marginTop: '2px' }}>Due: Jan 25, 2026</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Parents Tab */}
        <div className={`tab-content ${activeTab === 3 ? 'active' : ''}`}>
          <div className="tab-features">
            <ul>
              <li>Monitor child's attendance in real-time</li>
              <li>View academic performance and grades</li>
              <li>Pay fees online securely</li>
              <li>Communicate with teachers</li>
              <li>Track school bus location (GPS)</li>
              <li>Receive instant notifications</li>
            </ul>
          </div>
          <div className="tab-screenshot">
            <div style={{ width: '90%', height: '90%', display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ background: 'linear-gradient(135deg, #2563EB, #7C3AED)', borderRadius: '12px', padding: '20px', color: 'white' }}>
                <div style={{ fontSize: '13px', opacity: 0.9, marginBottom: '8px' }}>Child: Rahul Kumar - Grade 10A</div>
                <div style={{ display: 'flex', gap: '20px', marginTop: '12px' }}>
                  <div>
                    <div style={{ fontSize: '11px', opacity: 0.8 }}>Attendance</div>
                    <div style={{ fontSize: '22px', fontWeight: '900' }}>94%</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '11px', opacity: 0.8 }}>Last Exam</div>
                    <div style={{ fontSize: '22px', fontWeight: '900' }}>88/100</div>
                  </div>
                </div>
              </div>
              <div style={{ flex: 1, background: 'white', border: '2px solid #E2E8F0', borderRadius: '12px', padding: '16px' }}>
                <div style={{ fontSize: '13px', fontWeight: '700', color: '#0F172A', marginBottom: '12px' }}>Recent Notifications</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{ padding: '10px', background: '#D1FAE5', borderRadius: '8px', borderLeft: '3px solid #10B981' }}>
                    <div style={{ fontSize: '12px', fontWeight: '700', color: '#0F172A' }}>✓ Fee Payment Successful</div>
                    <div style={{ fontSize: '11px', color: '#64748B', marginTop: '2px' }}>Jan 15, 2026 - ₹15,000</div>
                  </div>
                  <div style={{ padding: '10px', background: '#DBEAFE', borderRadius: '8px', borderLeft: '3px solid #2563EB' }}>
                    <div style={{ fontSize: '12px', fontWeight: '700', color: '#0F172A' }}>📍 Bus Location Update</div>
                    <div style={{ fontSize: '11px', color: '#64748B', marginTop: '2px' }}>Bus #5 arriving in 10 mins</div>
                  </div>
                  <div style={{ padding: '10px', background: '#FEF3C7', borderRadius: '8px', borderLeft: '3px solid #F59E0B' }}>
                    <div style={{ fontSize: '12px', fontWeight: '700', color: '#0F172A' }}>📢 School Announcement</div>
                    <div style={{ fontSize: '11px', color: '#64748B', marginTop: '2px' }}>Annual Day on Jan 28, 2026</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Solutions;
